import { render, staticRenderFns } from "./add-base.vue?vue&type=template&id=ae8857d2&scoped=true&"
import script from "./add-base.vue?vue&type=script&lang=js&"
export * from "./add-base.vue?vue&type=script&lang=js&"
import style0 from "./add-base.vue?vue&type=style&index=0&id=ae8857d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8857d2",
  null
  
)

export default component.exports